import styled from 'styled-components';

export const CardWrapper = styled.div`
	background-color: #ffff;
	border-radius: 6px;
	box-shadow: 0px 1px 3px 0px #0000001f;
	padding: 13px 14px;
	min-width: 300px;
`;

export const TaskName = styled.span`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	font-size: 14px;
	font-weight: 500;
	line-height: 17px;
	text-align: left;
	color: #46389e;
	cursor: pointer;

	:hover {
		text-decoration: underline;
	}

	i {
		width: 8px;
		height: 8px;
	}
`;

export const HorizontalLine = styled.hr`
	width: calc(100% + 28px);
	left: -14px;
	position: relative;
`;

export const CommunityName = styled.span`
	display: block;
	font-size: 11px;
	font-weight: 400;
	line-height: 10.89px;
	text-align: left;
	margin-top: 6px;
`;

export const SectionTitle = styled.span`
	font-size: 11px;
	font-weight: 500;
	line-height: 10.89px;
	text-align: left;
	color: #31363a;
	display: block;
	margin-bottom: 5px;
`;

export const StatusName = styled.span`
	color: var(--Gray-700, #344054);
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 17px;
	margin: 0px 10px 0px 5px;
`;

export const StatusArea = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	vertical-align: middle;
	justify-content: left;
`;

export const LeftDot = styled.span<{ coreStatusId: number }>`
	display: block;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${(props) => getBackgroundColor(props.coreStatusId)};
`;

// Function to return different background colors based on coreStatusId
const getBackgroundColor = (coreStatusId: number): string => {
	switch (coreStatusId) {
		case 1:
			return '#6C757D'; // Red for "Not Started"
		case 2:
			return '#6C757D'; // Orange for "Not Applicable"
		case 3:
			return '#FF9F42'; // Green for "In Progress" or similar statuses
		case 4:
			return '#1EA97C'; // Blue for "Done"
		default:
			return '#6c757d'; // Default gray
	}
};

export const SectionSubtitle = styled.span`
	font-size: 10.5px;
	font-weight: 500;
	line-height: 10.5px;
	text-align: left;
	color: #6c757d;
	display: block;
`;

export const Signal = styled.div`
	width: 8px;
	height: 8px;
	display: flex;
	align-items: center;
`;
export const StatusDrop = styled.span`
	cursor: pointer;
`;

export const DateFormat = styled.div<{ isPastDue: boolean }>`
	:first-child {
		font-size: 11px;
		font-weight: 500;
		line-height: 10.89px;
		text-align: left;
		color: #31363a;
		display: block;
		margin-bottom: 5px;
		color: ${(props) => (props.isPastDue ? '#ff0000' : '#31363a')};
	}
	:last-child {
		font-size: 10.5px;
		font-weight: 500;
		line-height: 10.5px;
		text-align: left;
		color: #6c757d;
		display: block;
	}
`;

export const DropdownMenu = styled.div`
	background-color: #ffffff;
	border-radius: 6px;
	box-shadow: 0px 1px 3px 0px #0000001f;
	min-width: 150px;
	position: absolute;
	z-index: 1000;
	margin-top: 10px;
`;

export const DropdownItem = styled.div`
	padding: 8px 12px;
	cursor: pointer;
	display: flex;
	flex-direction: row;
	align-items: center;
	&:hover {
		background-color: #f0f0f0;
	}
`;
